var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHoverMenuHighlighti = function SvgHoverMenuHighlighti(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: props.color || 'currentColor'
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "none",
    stroke: "#fff",
    opacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.6 16a.65.65 0 0 1-.6-.6.65.65 0 0 1 .6-.6h8.8a.65.65 0 0 1 .6.6.65.65 0 0 1-.6.6zm0-3.4A.65.65 0 0 1 7 12a.65.65 0 0 1 .6-.6h8.8a.65.65 0 0 1 .6.6.65.65 0 0 1-.6.6zm0-3.4a.65.65 0 0 1-.6-.6.65.65 0 0 1 .6-.6h8.8a.65.65 0 0 1 .6.6.65.65 0 0 1-.6.6z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHoverMenuHighlighti);
export default ForwardRef;